import "./NavbarAppIcon.scss"

import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import cx from "classnames"

import env, { Environment } from "utils/env"

const NavbarAppIcon = () => {
    const { t } = useTranslation()

    const iconData = useMemo(() => {
        const info = getEnvironmentAdditionalInfo(env)

        if (!info) {
            return t('app.abbr')
        }
        return (
            <>
                <div>{t('app.abbr')}</div>
                <div className={cx([
                    "navbar-app-icon__caption",
                    `navbar-app-icon__caption--${info.styleClass}`
                ])}>{info.caption}</div>
            </>
        )

    }, [t])

    return (
        <div className="navbar-app-icon">
            {iconData}
        </div>
    )
}

function getEnvironmentAdditionalInfo(environment: Environment): IIconInfo | null {
    switch (environment) {
        case Environment.local:
            return {caption: "LOCAL", styleClass: "red"}
        case Environment.dev:
            return {caption: "DEV", styleClass: "red"}
        case Environment.test:
            return {caption: "TST1", styleClass: "gray"}
        case Environment.test2:
            return {caption: "TST2", styleClass: "gray"}
        case Environment.staging:
            return {caption: "TEST", styleClass: "dark"}
        default:
           return null
    }
}

interface IIconInfo {
    caption: string
    styleClass: string
}

export default NavbarAppIcon
